<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
	<van-button type="primary">主要按钮</van-button> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    // HelloWorld
  },

  metaInfo: {
    title: '哥弟商元企业官网', // set a title
    meta: [{ name: '哥弟', content: '哥弟商元隶属于哥弟集团旗下，作为全新的生活家居平台竭诚为大家提供集服装、家居、运动、美妆、健康等一系列多元化精品' },
      { name: '哥弟商元', content: '' },
      { name: '哥弟商元小程序', content: '' },
      { name: '哥弟商元是做什么的', content: '' },
      { name: '哥弟商元跟哥弟是什么关系', content: '' },
      { name: '哥弟商元跟哥弟是什么平台', content: '' },
      { name: '哥弟商元跟哥弟的区别', content: '' },
      { name: '哥弟商元怎么样', content: '' },
      { name: '哥弟商元老板', content: '' },
    ]
  }
}
</script>

<style>
	@import './assets/css/common.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.flex{
  display: flex;
}
.gflex{
  display: flex;
  align-items: center;
}
.flexjccenter{
  display: flex;
  justify-content: center;
}
.flexcenter{
  display: flex;
  align-items: center;
  justify-content: center;
}
.flexbet{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.alignend{
  align-items: flex-end;
}
.flexcolumn{
  flex-direction: column;
}
.flexwrap{ flex-wrap: wrap; }

.tacenter{text-align: center;}
.bgc_white{background-color: #FFFFFF;}
.gobyndmulit {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
/*单行文本超出隐藏*/
.gobyndsingle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
